import React from 'react';
import {API_URL} from '../global/components/Constants';
import { motion } from "framer-motion";
import { Typewriter } from "react-simple-typewriter";



export function ef(elem, code, duration){
    const ef = getEf(code, duration);
    return (
        <motion.div initial={ef.initial} animate={ef.animate} exit={ef.exit} transition={ef.transition}>
            {elem}
        </motion.div>
    )
}

export function efBounceUp(elem){
    return(
        <motion.div animate={{ y: [0, -10, 0] }}  transition={{repeat: Infinity, duration: 1.5, ease: "easeInOut" }}>
            {elem}
        </motion.div>
    )
}

export function efBounceRight(elem, speed){
    return(
        <motion.div animate={{ x: [0, speed, 0] }}  transition={{repeat: Infinity, duration: 1.5, ease: "easeInOut" }}>
            {elem}
        </motion.div>
    )
}

export function efWordByWord(text, speed){
    return (
        <div>
          <Typewriter
            words={[text]}
            loop={1} // Infinite loop
            typeSpeed={speed} // Typing speed
            deleteSpeed={30} // Speed for deleting words
            delaySpeed={1000} // Delay before typing next word
          />
        </div>
      );
}

export function efExpandContractComponent(elem){
    return (
      <div>
        <motion.div
            animate={{
                scale: [1, 1.1, 1], // Scale from original size to 1.5x and back to the original size
                opacity: [0.9, 1, 0.9],
                rotate: [0, 10, 0],
            }}
            transition={{
                repeat: Infinity,    // Repeat infinitely
                repeatType: 'loop',  // Loop back and forth
                duration: 2,         // Duration of one full cycle (expand + contract)
                ease: 'easeInOut',   // Smooth easing for the animation
            }}
        >
          {elem}
        </motion.div>
      </div>
    );
}

export function sparklingHr(){
    return (
        <div style={{ position: "relative", width: "100%" }}>
      {/* The visible HR element */}
      <hr style={{ margin:0, border: "none", height: "4px", backgroundColor: "#00a924" }} />
      
      {/* The moving colored bar */}
      <motion.div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          height: "4px", // Match the height of the hr element
          background: "linear-gradient(to right, #4de16d, #6ee38f)", // The gradient color effect
          width: "100%", // It should always span the full width of the hr
        }}
        initial={{ x: "-100%" }} // Start off-screen (left side)
        animate={{ x: "100%" }} // Move to the right side
        transition={{
          duration: 2, // Duration of the animation (2 seconds)
          repeat: Infinity, // Repeat the animation infinitely
          repeatType: "loop", // Loop the animation
          ease: "easeInOut", // Smooth easing
        }}
      />
    </div>
    )
}

function getEf(code, duration){
    const obj = efData.find(x=>x.code == code);
    if(obj != null){
        return {...obj, transition: { duration: duration, ease: "easeOut" }};
    }else{
        return {code: "zoom", initial: { scale: 0}, animate: { scale: 1}, exit: { scale: 1}, transition: { duration: 1, ease: "easeOut" }};
    } 
}

const efData = [
    {code: "zoom", initial: { scale: 0}, animate: { scale: 1}, exit: { scale: 1}, transition: { duration: 1, ease: "easeOut" }},
    {code: "left-right-slide", initial: { x: "-100%", opacity: 0 }, animate: { x: 0, opacity: 1 }, exit: { scale: 1 }, transition: { duration: 1, ease: "easeOut" }},
    {code: "right-left-slide", initial: { x: "100%", opacity: 0 }, animate: { x: 0, opacity: 1 }, exit: { scale: 1 }, transition: { duration: 1, ease: "easeOut" }},
    {code: "bottom-up-slide", initial: { y: "100%", opacity: 0 }, animate: { y: 0, opacity: 1 }, exit: { y: 100, opacity: 0 }, transition: { duration: 0.5, ease: "easeOut" }}
]